import request from '@/utils/request'

export function upload(formData) {
  return request({
    url:'/fileManager/uploadFile',
    method:'post',
    data: formData
  })
}

export function uploadVideo(formData, token) {
  return request({
    url:'/fileManager/uploadVideo',
    method:'post',
    config:{
      headers:{'Content-Type':'multipart/form-data','token':token}
    },
    data: formData
  })
}

export function uploadPicture(formData,token) {
  return request({
    url:'/fileManager/uploadPicture',
    method:'post',
    config:{
      headers:{'Content-Type':'multipart/form-data','token':token}
    },
    data: formData
  })
}